import * as i0 from "@angular/core";
export class EquipmentData {
}
EquipmentData.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentData_Factory() { return new EquipmentData(); }, token: EquipmentData, providedIn: "root" });
